import { Surface } from '../../../../specification/Surface';
import { getPropertyValue } from '../../../../specification/cases/Property';
import { CaseSpecification } from '../../../../specification/cases/CaseSpecification';

export const getCaseProjectedHallSurface = (caseSpecification: CaseSpecification): Surface =>
  new Surface(
    Math.max(0, (getPropertyValue('hallSurface')(caseSpecification.properties) as number) || 0)
  );
